import { useState } from "react";

interface Tab {
  label: string;
  content: React.ReactNode;
}

interface TabSectionProps {
  tabs: Tab[];
}

const TabSection = ({ tabs }: TabSectionProps) => {
  const [active, setActive] = useState(0);

  return (
    <div>
      {/* Tab bar */}
      <div className="flex border-b border-border mb-8 overflow-x-auto">
        {tabs.map((tab, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`flex-shrink-0 font-body text-xs uppercase tracking-widest px-5 py-3 transition-colors duration-200 border-b-2 -mb-px ${
              i === active
                ? "border-accent text-accent"
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active content */}
      <div>{tabs[active]?.content}</div>
    </div>
  );
};

export default TabSection;
